module.exports = __webpack_public_path__ + "static/img/logo.c7a9ccb.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/logo.png
// module id = jBS0
// module chunks = 12